import tw from 'twin.macro';
import { useState, useEffect } from 'react';
import type { SvgIconProps } from '@mui/material';

export default function Icon({ name, className }: { name: keyof typeof import('@mui/icons-material'), className?: string }) {
  const [ IconComponent, setIconComponent ] = useState<React.ComponentType<SvgIconProps> | null>(null);

  useEffect(() => {
    import('@mui/icons-material')
      .then((module) => {
        setIconComponent(() => module[name]);
      })
      .catch((error) => {
        console.error(`Error loading icon ${ name }:`, error);
      });
  }, [ name ]);

  if (!IconComponent) {
    return null; // Or a loading state
  }

  return (
    <div className={ `flex w-6 h-6 ${ className }` }>
      <IconComponent
        sx={ tw`w-full h-full` }
      />
    </div>
  );
}
